import { v4 as uuid }                        from 'uuid';
import { BaseStore }                         from './BaseStore';
import { asType, isResolver, withResolvers } from './_apolloUtil';

@withResolvers
export class UIStore extends BaseStore {
	
	static storeKey      = 'ui';
	static storeTypename = 'UIStore';
	static typeDefs      = `
		type UIStore{
			guid: String
		}
	`;
	
	static state = asType( UIStore.storeTypename, {
		guid: uuid()
	} );
}
